import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { useAppContext } from "../../context/AppContext";

function CustomDialog({
  children,
  show,
  close,
  closeWhenClickedOutside = true,
}) {
  const appState = useAppContext();
  return (
    <>
      <Transition appear show={show} as={Fragment}>
        <Dialog
          as="div"
          className={`${appState.state.darkMode ? "dark" : ""} relative z-50`}
          onClose={() => {
            if (closeWhenClickedOutside) close();
          }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 backdrop-blur-md " />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="translate-y-full opacity-0 scale-95"
            enterTo="translate-y-0 opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="translate-y-0 opacity-100 scale-100"
            leaveTo="translate-y-full opacity-0 scale-95"
          >
            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                {children}
              </div>
            </div>
          </Transition.Child>
        </Dialog>
      </Transition>
    </>
  );
}

export default CustomDialog;
